const watob = ( data ) => {
    return ( typeof window !== 'undefined' ) ? window.atob( data ) : Buffer.from( data, 'base64' ).toString( );
};
const parse = ( token ) => {
    var base64Url = token.split( '.' )[ 1 ];
    var base64 = base64Url.replace( /-/g, '+' ).replace( /_/g, '/' );
    var jsonPayload = decodeURIComponent( watob( base64 ).split( '' ).map( function( c ) {
        return '%' + ( '00' + c.charCodeAt( 0 ).toString( 16 ) ).slice( -2 );
    } ).join( '' ) );

    return JSON.parse( jsonPayload );
};

const getUserFromToken = ( accessToken ) => {
    let parsed = parse( accessToken );

    let user = parsed[ 'user' ];
    user.policies = parsed[ 'policies' ];
    return user;
};

const hasPolicyWithAnyAction = ( user, ...actions ) => {
    if ( !user || !user.policies ) {
        return false;
    }

    for ( const policy of user.policies ) {
        for ( const action of policy.action ) {
            for ( const destinationAction of actions ) {
                if ( action === destinationAction ) {
                    return true;
                }
            }
        }
    }

    return false;
};

const hasPolicyWithAllActions = ( user, ...actions ) => {
    if ( !user || !user.policies ) {
        return false;
    }

    for ( const action of actions ) {
        var found = false;

        for ( const policy of user.policies ) {
            for ( const policyaction of policy.action ) {
                if ( policyaction == action ) {
                    found = true;
                    break;
                }
            }
            if ( found ) {
                break;
            }
        }

        if ( !found ) {
            return false;
        }
    }

    return true;
};

// check if action requires login to be specified in matching policy
// if any of the actions do not require login, return false
const requiresLoginForAction = ( user, ...actions ) => {
    for ( const action of actions ) {
        for ( const policy of user.policies ) {
            for ( const policyaction of policy.action ) {
                if ( policyaction == action ) {
                    // if there is no condition then it does NOT require login
                    if ( !policy.condition ) {
                        return false;
                    }
                    // if there is a condition and it does not require login, return false
                    if ( !policy.condition.loginRequired ) {
                        return false;
                    }
                }
            }
        }
    }

    return true;
};

export { parse, getUserFromToken, hasPolicyWithAnyAction, hasPolicyWithAllActions, requiresLoginForAction };



// WEBPACK FOOTER //
// ./src/auth/index.js